import React from 'react'
import Navbar from '../layouts/Navbar'
import Footer from '../Footer'

const PrivacyPolicy = () => {
  return (
    <div>
      <Navbar/>
      PrivacyPolicy
      <Footer/>
    
    </div>
  )
}

export default PrivacyPolicy
